import ExternalLink from '../../../Routing/ExternalLink'
import Link from '../../../Routing/Link'
import ListImage from '../../../../legacy_components/Image/Rendition/List'
import MediaContainer from '../../../../widgets/Layout/MediaContainer'
import Tag from '../../../../widgets/Typography/Tag'
import Title from '../../../../widgets/Typography/Title'
import PropTypes from 'prop-types'
import React from 'react'
import RelativeTimeWithIcon from '../../../../widgets/Temporal/RelativeTimeWithIcon'
import { getLocales } from '../../../../utilities/locales'
import { isInternalUrl } from '../../../../utilities/urls'
import styles from './Vertical.module.css'

const VerticalContent = ({ locale, marketSpace, sponsoredTitle }) =>
  <div className={ styles.content }>
    <div className={ styles.cover }>
      <MediaContainer>
        <ListImage src={ marketSpace.image.href } lazy={ true }/>
      </MediaContainer>
    </div>

    <div className={ styles.information }>
      <div className={ styles['top-information'] }>
        <Tag variant="sponsored">{ sponsoredTitle }</Tag>
        { marketSpace.title
          ? <Title>{ marketSpace.title }</Title>
          : null
        }
      </div>

      <div className={ styles['bottom-information'] }>
        <RelativeTimeWithIcon
          date={ marketSpace.createdAt }
          locale={ locale }
        />
      </div>
    </div>
  </div>

const Vertical = ({
  locale,
  marketSpace,
  sponsoredTitle = null,
  click,
}) =>
  <div className={ styles.wrapper }>
    { marketSpace.link && isInternalUrl(marketSpace.link)
      ? <Link
        href={ marketSpace.link }
        onClick={ () => click(marketSpace.id) }
        variant="block"
      >
        <VerticalContent
          marketSpace={ marketSpace }
          locale={ locale }
          sponsoredTitle={ sponsoredTitle }
        />
      </Link>
      : null
    }

    { marketSpace.link && !isInternalUrl(marketSpace.link)
      ? <ExternalLink
        href={ marketSpace.link }
        onClick={ () => click(marketSpace.id) }
        preventDefault={ false }
        variant="block"
      >
        <VerticalContent
          marketSpace={ marketSpace }
          locale={ locale }
          sponsoredTitle={ sponsoredTitle }
        />
      </ExternalLink>
      : null
    }

    { !marketSpace.link
      ? <VerticalContent
        marketSpace={ marketSpace }
        locale={ locale }
        sponsoredTitle={ sponsoredTitle }
      />
      : null
    }
  </div>

Vertical.propTypes = {
  marketSpace: PropTypes.object.isRequired,
  locale: PropTypes.oneOf(getLocales()).isRequired,
  sponsoredTitle: PropTypes.string,
  click: PropTypes.func.isRequired,
}

export default Vertical
